import React, { createRef, useEffect, useRef, useState, useCallback } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Container } from "reactstrap";
import DataTable, { TableColumn } from 'react-data-table-component';
import { Dictionary_Calendario_Directivo, Rows_Calendario_Directivo } from './PlanificacionVacaciones';
import axios from 'axios';
//URL
import configData from "../../../config.json";
import { handle_error } from './helper_function';
import { authenticationService } from 'services/authentication.service';
import Cargando from 'components/Varios/Cargando';
import { formatoFecha, parseo_mes } from 'components/Admin/Inicio-Admin/Dashboard_Individual_Admin';
import PlanificacionVacaciones, { ESTADO_APROBACION_PARCIAL, ESTADO_APROBADO, ESTADO_ENVIADO_TALENTO_HUMANO, ESTADO_NO_HA_PLANIFICADO, ESTADO_PENDIENTE, ESTADO_RECHAZADO, ESTADO_TIENE_RECHAZADAS } from 'components/UsuarioGeneral/Vacaciones/Planificacion Vacaciones/PlanificacionVacaciones';
import { Datos_Aprobar_Rechazar, PRIMER_APROBADOR } from './ModalDirectivo';
import $ from 'jquery';

import { ReactComponent as IconoEnviado } from "../../../assets/icons/enviado.svg"
import { ReactComponent as Reprogramado } from "../../../assets/icons/Reprogramado.svg"


type respuestaCalendarioMensual = {
    calendario_mensual: Array<Dictionary_Calendario_Directivo>
}
type Props_ModalAprobar = {

    show: boolean
    toogle: () => void
    mes_consulta: number
    onClose: () => void
    anio: number | undefined,
    color: string,
    tipo_aprobador: string,
    mostrar_boton_enviar: boolean,
    tipo_personal: string,
    isDelegado: boolean


}

type ObservacionPlanificacion = {
    idplanificacion: number,
    observacion: string,
}

type ActualizarPlanificacionMensual = {
    fechainicio: Date,
    fechaFin: Date,
    estadoAprobacion: string,
    idplanificacion: number,
    idpersona: number,
    observacion?: string,
}

const ModalConsultaMensual: React.FC<Props_ModalAprobar> = (props: Props_ModalAprobar) => {

    //estados
    const [loading, setloading] = useState<boolean>(true)
    const [progressPending, setprogressPending] = useState<boolean>(true)
    const [tabla_consulta_mes, settabla_consulta_mes] = useState<JSX.Element>()
    const [rowsTabla, setrowsTabla] = useState<Array<Rows_Calendario_Directivo>>([])
    const [tipo_aprobador, settipo_aprobador] = useState<string>("")
    //Tabla 
    const [filterText, setFilterText] = useState<string>('');
    const [filterSelect, setfilterSelect] = useState<string>('');
    const [observaciones, setobservaciones] = useState<Array<ObservacionPlanificacion>>([])
    //APROBAR RECHAZAR
    const [datos_aprobar_rechazar, setdatos_aprobar_rechazar] = useState<Datos_Aprobar_Rechazar>({ accion: "", idplanificacion: -1 })
    //Enviar o Confirmar acciones
    const [enviar, setenviar] = useState<number>(-1);
    //Texto advertencia
    const [textoAdvertencia, settextoAdvertencia] = useState<string>("")
    //Errores
    const [listaErrores, setlistaErrores] = useState<Array<string>>([]);
    //Referencias
    const refModal = useRef<JSX.Element>(null)
    //Confirmacion
    const [enviado, setenviado] = useState<boolean>(false)


    const ComponentBuscadorTabla = (): JSX.Element => {
        return (
            <React.Fragment>
                <Row className="align-items-center">
                    <Col xl={6} sm={12} className="text-sm-center align-self-center">
                        <select name="select" onChange={(e) => setfilterSelect(e.target.value)}>
                            <option value={"T"} selected>{"TODOS LOS ESTADOS"}</option>
                            <option value={ESTADO_PENDIENTE}>{"PENDIENTE"}</option>
                            <option value={ESTADO_APROBADO}>{"APROBADO"}</option>
                            <option value={ESTADO_RECHAZADO} >{"RECHAZADO"}</option>
                            {/* <option value={ESTADO_TIENE_RECHAZADAS} >{"TIENE RECHAZADAS"}</option> */}
                            <option value={ESTADO_APROBACION_PARCIAL} >{"APROBADO PARCIALMENTE"}</option>
                            {/* <option value={ESTADO_NO_HA_PLANIFICADO} >{"NO PLANIFICADO "}</option> */}

                        </select>
                    </Col>
                    <Col xl={6} sm={12} className="mt-sm-2 text-sm-center align-self-center">
                        <input value={filterText} onChange={(e) => setFilterText(e.target.value)} placeholder="buscar nombre"></input>

                    </Col>
                </Row>
            </React.Fragment>

        );
    }

    const modificar_planificacion_calendario_tabla = (idplanificacion: number, estado: string, todo: boolean = false) => {
        var copiaRowsTabla: Array<Rows_Calendario_Directivo> = [...rowsTabla];
        var indice_planificacion = copiaRowsTabla.findIndex((planificacion_vacaciones) => planificacion_vacaciones.idplanificacion == idplanificacion);
        if (indice_planificacion !== -1 && !todo) {
            copiaRowsTabla[indice_planificacion].estado = estado
        }
        else if (todo) {
            copiaRowsTabla.map((valores_copia) =>
                valores_copia.estado = estado
            )
        }
        return copiaRowsTabla;
    }
    const auxiliar_aprobar = (idplanificacion: number) => {

        var planificacion_modificada = modificar_planificacion_calendario_tabla(idplanificacion, ESTADO_APROBADO);
        setrowsTabla(planificacion_modificada);

    }
    const auxiliar_aprobar_todo = () => {
        var planificacion_modificada = modificar_planificacion_calendario_tabla(0, ESTADO_APROBADO, true);
        setrowsTabla(planificacion_modificada);
    }
    const auxiliar_rechazar = (idplanificacion: number) => {
        var planificacion_modificada = modificar_planificacion_calendario_tabla(idplanificacion, ESTADO_RECHAZADO);
        setrowsTabla(planificacion_modificada);
    }



    useEffect(() => {
        setloading(true)
        if (rowsTabla && (filterText != "" || filterSelect != "")) {
            var filtrado: Array<Rows_Calendario_Directivo> = rowsTabla;
            if (filterSelect != "") {
                if (filterSelect != "T") {
                    filtrado = filtrado.filter(item => {
                        return item.estado && item.estado == filterSelect
                    })
                }

            }
            if (filterText != "") {
                filtrado = filtrado.filter(item => {
                    return item.personal && item.personal.toLowerCase().includes(filterText.toLowerCase())
                })
            }

            settabla_consulta_mes(generar_tabla_consulta_mensual(filtrado, props.tipo_aprobador, props.mostrar_boton_enviar))

        }
        else if (filterText === "" && rowsTabla) {
            var filtrado: Array<Rows_Calendario_Directivo> = rowsTabla;

            if (filterSelect != "") {
                if (filterSelect != "T") {
                    filtrado = filtrado.filter(item => {
                        return item.estado && item.estado == filterSelect
                    })
                }

            }
            settabla_consulta_mes(generar_tabla_consulta_mensual(filtrado, props.tipo_aprobador, props.mostrar_boton_enviar))
        }
        setloading(false)

    }, [filterText, filterSelect, rowsTabla, props.tipo_aprobador, props.mostrar_boton_enviar]);


    useEffect(() => {
        const { accion, idplanificacion } = datos_aprobar_rechazar;
        if (accion === "A" && idplanificacion !== -1) {
            auxiliar_aprobar(idplanificacion);
        }
        else if (accion === "R" && idplanificacion !== -1) {
            auxiliar_rechazar(idplanificacion);
        }


    }, [datos_aprobar_rechazar.accion, datos_aprobar_rechazar.idplanificacion])


    useEffect(() => {
        if (rowsTabla.length !== 0 && props.tipo_aprobador !== "") {
            settabla_consulta_mes(generar_tabla_consulta_mensual(rowsTabla, props.tipo_aprobador, props.mostrar_boton_enviar))
        }
    }, [rowsTabla, props.tipo_aprobador, props.mostrar_boton_enviar])

    const generar_tabla_consulta_mensual = (datos_planificacion_directivo: Array<Rows_Calendario_Directivo>, tipo_aprobador: string, aprobado_todo_parcialmente: boolean): JSX.Element => {


        function generar_icon_tabla_mensual(estado: string | undefined, estadoreplanificacion: string | null) {
            console.log(estadoreplanificacion)
            var icono = <i></i>;
            var clase_aprobar = "far fa-check-circle opcion_aprobar_planificacion"
            var clase_rechazar = "far fa-times-circle opcion_rechazar_planificacion"
            var clase_pendiente = "fas fa-ellipsis-h pendiente_icono_tabla_mensual"
            if (estado != undefined) {



                if (estado === ESTADO_APROBADO) {
                    // icono = <i className={clase_aprobar} data-bs-toggle="tooltip" data-bs-placement="top" title="Aprobado"></i>;
                    icono = <div className="pendiente_icono_tabla_mensual">APROBADO</div>

                }
                else if (estado === ESTADO_RECHAZADO) {
                    // icono = <i className={clase_rechazar} data-bs-toggle="tooltip" data-bs-placement="top" title="Rechazado"></i>
                    icono = <div className="pendiente_icono_tabla_mensual">RECHAZADO</div>

                }
                else if (estado === ESTADO_TIENE_RECHAZADAS) {
                    // icono = <i className={clase_rechazar} data-bs-toggle="tooltip" data-bs-placement="top" title="Rechazado"></i>
                    icono = <div className="pendiente_icono_tabla_mensual">TIENE RECHAZADAS</div>

                }
                else if (estado.trim() === ESTADO_PENDIENTE) {

                    icono = <div className="pendiente_icono_tabla_mensual">PENDIENTE</div>
                }
                else if (estado.trim() === ESTADO_APROBACION_PARCIAL) {
                    icono = <div className="pendiente_icono_tabla_mensual">APROBADO PARCIALMENTE</div>

                }
                else if (estado.trim() === ESTADO_ENVIADO_TALENTO_HUMANO && estadoreplanificacion !== null && estadoreplanificacion.trim() === "RPO") {
                    icono = <div className="estado_replanificada">
                        <div className="estadoFirstElement">PLANIF. REPROGRAMADA <Reprogramado height={20} width={20} /></div>
                        
                    </div>
                }
                else if (estado.trim() === ESTADO_ENVIADO_TALENTO_HUMANO && estadoreplanificacion !== null && estadoreplanificacion.trim() === "RPA") {
                    icono = <div className="estado_planificacion_vigente">
                        <div className="estadoFirstElement">EVDO. A DTH</div>
                        <IconoEnviado height={20} width={20} />

                    </div>

                }
                else if (estado.trim() === ESTADO_ENVIADO_TALENTO_HUMANO) {
                    icono = <div className="estado_planificacion_vigente">
                        <div className="estadoFirstElement">EVDO. A DTH</div>
                        <IconoEnviado height={20} width={20} />

                    </div>

                }

                return (
                    <React.Fragment>
                        {icono}
                    </React.Fragment>
                );
            }

        }
        const customStyles_tabla = {
            table: {
                style: {
                    border: "solid 1px"
                },
            },
            header: {
                style: {
                    fontSize: '22px',
                    backgroundColor: "#243165",
                    color: "white",

                },
            },

            headRow: {
                style: {
                    backgroundColor: "#243165",
                    color: "white",
                    fontSize: '1em',

                },
                denseStyle: {
                    minHeight: '32px',
                },
            },
            rows: {
                style: {
                    minHeight: '50px', // override the row height
                    fontSize: '1em',
                    "text-align": "left",
                },
            },

        };

        const mostrar_fecha_tabla = (fecha_formatear: Date) => {
            var particion = formatoFecha(fecha_formatear.toISOString()).split("/")

            return particion[0] + "/" + particion[1]
        }

        const aprobar_planificacion = (idplanificacion: number) => {

            setdatos_aprobar_rechazar({ accion: "A", idplanificacion });

        }
        const rechazar_planificacion = (idplanificacion: number) => {
            setdatos_aprobar_rechazar({ accion: "R", idplanificacion });

        }

        const generar_acciones_tabla = (idplanificacion: number, estado: undefined | string, tipo_aprobador: string, iddirectivo_asignado: number) => {
            var clase_aprobar = "far fa-check-circle "
            var clase_rechazar = "far fa-times-circle"
            var clase_parcial = "far fa-check-circle "
            var datos = authenticationService.currentUserValue;
            if (estado != undefined) {
                var estado_unificado = estado.trim().toUpperCase();
                if (estado_unificado === ESTADO_APROBADO) {
                    clase_aprobar += " opcion_aprobar_planificacion";
                }
                else if (estado_unificado === ESTADO_RECHAZADO) {
                    clase_rechazar += " opcion_rechazar_planificacion";
                }
                else if (estado_unificado === ESTADO_APROBACION_PARCIAL) {
                    clase_parcial += " opcion_parcial";
                }


                // if (iddirectivo_asignado !== datos.idpersona) {
                if (iddirectivo_asignado !== null && iddirectivo_asignado !== 0 && tipo_aprobador === PRIMER_APROBADOR) {
                    return (
                        <React.Fragment>
                            {
                                tipo_aprobador === PRIMER_APROBADOR && estado_unificado === ESTADO_APROBACION_PARCIAL &&
                                <i className={clase_parcial} data-bs-toggle="tooltip" data-bs-placement="top" title="Aprobado Parcialmente" data-bs-custom-class="toogle_personalizado_aprobar" ></i>
                            }
                            {
                                estado_unificado === ESTADO_APROBADO &&
                                <i className={clase_aprobar} data-bs-toggle="tooltip" data-bs-placement="top" title="Aprobado por Directivo" data-bs-custom-class="toogle_personalizado_aprobar" ></i>

                            }
                            {
                                estado_unificado === ESTADO_RECHAZADO &&
                                <i className={clase_rechazar} data-bs-toggle="tooltip" data-bs-placement="top" title="Rechazado" ></i>

                            }



                        </React.Fragment>
                    );
                }
                else {
                    if (estado_unificado === ESTADO_ENVIADO_TALENTO_HUMANO) {
                        return <i></i>
                    }
                    return (
                        <React.Fragment>
                            {

                            }
                            {
                                tipo_aprobador === PRIMER_APROBADOR && estado_unificado === ESTADO_APROBACION_PARCIAL ?
                                    <i className={clase_parcial} data-bs-toggle="tooltip" data-bs-placement="top" title="Aprobar" data-bs-custom-class="toogle_personalizado_aprobar" ></i>
                                    :
                                    <i className={clase_aprobar} data-bs-toggle="tooltip" data-bs-placement="top" title="Aprobar" data-bs-custom-class="toogle_personalizado_aprobar" onClick={() => { aprobar_planificacion(idplanificacion) }}></i>
                                // <i className={clase_aprobar} data-bs-toggle="tooltip" data-bs-placement="top" title="Aprobar" data-bs-custom-class="toogle_personalizado_aprobar" onClick={() => {}}></i>

                            }
                            {
                                <i className={clase_rechazar} data-bs-toggle="tooltip" data-bs-placement="top" title="Rechazar" onClick={() => { rechazar_planificacion(idplanificacion) }}></i>
                                // <i className={clase_rechazar} data-bs-toggle="tooltip" data-bs-placement="top" title="Rechazar" onClick={() => {  }}></i>
                            }



                        </React.Fragment>
                    );
                }


            }
        }

        const handle_input_observacion = (texto_observacion: string, idplanifcacion: number) => {
            var copia_observaciones = [...observaciones]
            var indice_busco = copia_observaciones.findIndex((obs) => obs.idplanificacion == idplanifcacion)
            if (indice_busco === -1) {
                copia_observaciones.push({
                    idplanificacion: idplanifcacion,
                    observacion: texto_observacion
                })
            }
            else {
                copia_observaciones[indice_busco].observacion = texto_observacion;
            }
            setobservaciones(copia_observaciones);

        }


        const generar_input_observacion_tabla = (estado: undefined | string, observacion: string | undefined, idplanificacion: number): JSX.Element => {
            if (estado === ESTADO_RECHAZADO) {
                return (
                    <React.Fragment>
                        <div>
                            <p>Ingrese la observación</p>
                            <input type="text" onChange={(e) => handle_input_observacion(e.target.value.toUpperCase(), idplanificacion)} />
                        </div>
                    </React.Fragment>
                );
            }
            return <div></div>

        }

        const columns: TableColumn<Rows_Calendario_Directivo>[] = [

            {
                name: 'Personal',
                selector: row => row.personal,
                sortable: true,
                width: "300px"
            },
            {
                name: 'Desde',
                selector: row => new Date(row.desde).getDay(),
                sortable: true,
                maxWidth: '5%',
                cell: row => mostrar_fecha_tabla(new Date(row.desde))

            },
            {
                name: 'Hasta',
                selector: row => new Date(row.hasta).getDay(),
                sortable: true,
                maxWidth: '5%',
                cell: row => mostrar_fecha_tabla(new Date(row.hasta))

            },
            {
                name: 'Días',
                selector: row => row.dias,
                sortable: true,
                maxWidth: '2%'
            },
            {
                name: 'Estado',
                selector: row => row.estado ? row.estado : "",
                sortable: true,
                cell: row => generar_icon_tabla_mensual(row.estado, row.estadoreplanificacion),
                maxWidth: '25%',
                width: "150px"
            },
            {
                name: 'Accion',
                cell: row => generar_acciones_tabla(row.idplanificacion, row.estado, tipo_aprobador, row.iddirectivo)
            },
            {
                name: 'Observación',
                cell: (row) => row.observacion ? row.observacion : generar_input_observacion_tabla(row.estado, row.observacion, row.idplanificacion),
                minWidth: "30%",
                width: "300px"
            }

        ]


        return (<DataTable columns={columns}
            data={datos_planificacion_directivo}
            subHeaderComponent={ComponentBuscadorTabla()}
            subHeader={true}
            responsive={true}
            progressPending={progressPending}
            striped
            customStyles={customStyles_tabla} />)

    }

    function cerrar_modal() {
        setloading(true);
        settabla_consulta_mes(undefined)
        settextoAdvertencia("")
        setobservaciones([])
        setFilterText("")
        setfilterSelect("")
        setprogressPending(true)
        props.toogle()
    }

    useEffect(() => {
        const Obtener_datos_calendario_mensual = async () => {

            const currentUser = authenticationService.currentUserValue;

            try {
                const respuesta = await axios.get(configData.SERVER_URL + `PlanificacionVacaciones/Directivo/CalendariosMes/${props.mes_consulta}/${props.tipo_personal}`,
                    {
                        headers: {
                            Authorization: `KEYESPOL ${currentUser?.token}`
                        }


                    });

                var respuesta_calendario: respuestaCalendarioMensual = respuesta.data;
                var rows_tabla: Array<Rows_Calendario_Directivo> = respuesta_calendario.calendario_mensual[0].value.calendarioPlanificacionUsuario;

                const arregloObservacionesPlanificaciones: ObservacionPlanificacion[] = [];

                for (var i = 0; i < rows_tabla.length; i++) {

                    const planifUsuario: Rows_Calendario_Directivo = rows_tabla[i];

                    if (planifUsuario.observacion) {
                        arregloObservacionesPlanificaciones.push({
                            idplanificacion: planifUsuario.idplanificacion,
                            observacion: planifUsuario.observacion
                        })
                    }

                }

                if (arregloObservacionesPlanificaciones.length > 0) {
                    setobservaciones(arregloObservacionesPlanificaciones);
                }

                settipo_aprobador(props.tipo_aprobador);
                setrowsTabla(rows_tabla);
                settabla_consulta_mes(generar_tabla_consulta_mensual(rows_tabla, props.tipo_aprobador, props.mostrar_boton_enviar))
            } catch (error) {
                var status_number: number = handle_error(error)

            }

        }



        if (props.mes_consulta !== -1 && props.tipo_aprobador !== "") {
            setloading(true)
            Obtener_datos_calendario_mensual();
            setloading(false);
            setprogressPending(false);


        }
    }, [props.mes_consulta, props.tipo_aprobador, props.mostrar_boton_enviar])


    const handlevalorenviar = (valor: number) => {
        return valor + 1;
    }
    useEffect(() => {
        const handleenviaraprobacionrechazo = async () => {
            setloading(true);
            const currentUser = authenticationService.currentUserValue;
            //Observacion si esta rechazado
            var copia_listado_actualizar: Array<ActualizarPlanificacionMensual> = [];
            var bandera_rechazo_sin_observacion = false;
            rowsTabla.map((planif_actualizar) => {

                var copia_planif_actual: Rows_Calendario_Directivo = planif_actualizar;
                if (copia_planif_actual.estado === ESTADO_RECHAZADO) {
                    var indice_busco = observaciones.findIndex((obs) => obs.idplanificacion == planif_actualizar.idplanificacion);
                    bandera_rechazo_sin_observacion = indice_busco === -1
                    if (!bandera_rechazo_sin_observacion) {
                        copia_planif_actual.observacion = observaciones[indice_busco].observacion
                    }


                    copia_listado_actualizar.push({
                        fechainicio: copia_planif_actual.desde,
                        fechaFin: copia_planif_actual.hasta,
                        estadoAprobacion: copia_planif_actual.estado,
                        idpersona: copia_planif_actual.idpersona,
                        idplanificacion: copia_planif_actual.idplanificacion,
                        observacion: copia_planif_actual.observacion
                    });
                }
                else if (copia_planif_actual.estado === ESTADO_APROBADO) {
                    copia_listado_actualizar.push({
                        fechainicio: copia_planif_actual.desde,
                        fechaFin: copia_planif_actual.hasta,
                        estadoAprobacion: copia_planif_actual.estado,
                        idpersona: copia_planif_actual.idpersona,
                        idplanificacion: copia_planif_actual.idplanificacion,
                        observacion: copia_planif_actual.observacion
                    });

                }

            })

            if (bandera_rechazo_sin_observacion) {
                settextoAdvertencia("Ha rechazado una planificación sin colocar una observación");

                $('#modal_consulta_mes_aprobacion').animate({ scrollY: -100 }, 'slow');
            }
            else {
                settextoAdvertencia("")
                try {


                    const respuesta_aprobacionrechazo = await axios.post(configData.SERVER_URL + `PlanificacionVacaciones/Directivo/AprobarRechazar/Mensual`,
                        copia_listado_actualizar,
                        {
                            headers: {
                                Authorization: `KEYESPOL ${currentUser?.token}`
                            }


                        });


                    setenviado(true)
                    window.location.reload();

                } catch (error) {
                    var error_any: any = error;
                    var status = handle_error(error_any);
                    switch (status) {
                        case 400:
                            var respuesta = error_any.response;
                            if (respuesta.data.errors) {
                                var problemas: Array<string> = respuesta.data.errors["Actualizar_Planificacion"];
                                setlistaErrores(problemas);
                            }
                            break;
                        case 0:
                            var problemas: Array<string> = [...listaErrores];
                            problemas.push("No se pudo establecer conexion con el servidor")

                            break;
                        default:
                            var problemas: Array<string> = [...listaErrores];
                            problemas.push("Error desconocido")
                            break;
                    }



                }

            }


            setloading(false);

        }


        if (enviar > -1 && rowsTabla.length !== 0) {
            handleenviaraprobacionrechazo();
        }
    }, [enviar, rowsTabla, observaciones])



    return (
        <Modal
            id="modal_consulta_mes_aprobacion"
            ref={refModal}
            isOpen={props.show}
            scrollable={true}
            size={"xl "}
            fullscreen={"xl"}
            centered={true}
            onClosed={props.onClose}
        >
            <ModalHeader close={<button onClick={() => cerrar_modal()} >x</button>} />
            <ModalBody  >
                <p className="titulo_planificacion_vacaciones">Planificación vacaciones  </p>
                {
                    loading && <Cargando />
                }
                {
                    !loading && tabla_consulta_mes === undefined && <Cargando />
                }
                {!loading &&
                    <Container>
                        <Row className="justify-content-start">
                            <Col xl={3}>
                                <div className="cabecera_mes_modal_directivo" style={{ color: props.color }} >{parseo_mes[props.mes_consulta - 1] + " " + props.anio}</div>

                            </Col>
                        </Row>
                        {/* <Row className="justify-content-end">
                            <Col xl={2}>
                                {tabla_consulta_mes !== undefined && props.mostrar_boton_enviar &&
                                    <div className="container_botones">
                                        <button className={"btnAprobarTodo"} onClick={() => auxiliar_aprobar_todo()}>Marcar todos como aprobados</button>
                                    </div>

                                }
                            </Col>
                        </Row> */}
                        <Row className="justify-content-center mt-1 mb-1">
                            <Col xl={12}>
                                {!loading && tabla_consulta_mes}
                                {!tabla_consulta_mes && loading
                                }
                            </Col>
                        </Row>
                        <Row className="justify-content-center mt-1 mb-1">
                            {textoAdvertencia !== "" && !enviado
                                &&
                                <Col xl={12}>
                                    <div className="alerta_advertencia">
                                        <div className="cabecera_alerta_red">
                                            Advertencia
                                        </div>
                                        <div className="cuerpo_alerta">
                                            {textoAdvertencia}
                                        </div>
                                    </div>
                                </Col>
                            }

                        </Row>
                        <Row className="justify-content-center mt-1 mb-1">
                            {listaErrores.length !== 0 && !enviado
                                &&
                                <Col xl={12}>
                                    <div className="alerta_advertencia">
                                        <div className="cabecera_alerta_red">
                                            Error
                                        </div>
                                        <div className="cuerpo_alerta">
                                            {listaErrores.map((texto, indice) => {
                                                return (
                                                    <div key={"texto_error_mensual_actualizacion" + indice}> {texto}</div>
                                                )
                                            }
                                            )}
                                        </div>
                                    </div>
                                </Col>
                            }

                        </Row>
                        <Row className="justify-content-center mt-1 mb-1">
                            {listaErrores.length === 0 && enviado
                                &&
                                <Col xl={12}>
                                    <div className="alerta_exito">
                                        <div className="cabecera_alerta_green">
                                            Mensaje
                                        </div>
                                        <div className="cuerpo_alerta_green">

                                            Se han confirmado sus acciones. Espere un momento por favor
                                        </div>
                                    </div>
                                </Col>
                            }

                        </Row>
                        <Row className="justify-content-end">

                            <Col xs={12} md={4} lg={4} xl={3} className="text-sm-center">
                                {tabla_consulta_mes !== undefined && props.mostrar_boton_enviar && !props.isDelegado &&
                                    <div className="container_botones">
                                        <button className={"btnAprobarTodo"} onClick={() => auxiliar_aprobar_todo()}>Marcar todos como aprobados</button>
                                    </div>

                                }
                            </Col>

                            {
                                tabla_consulta_mes !== undefined && props.mostrar_boton_enviar && !props.isDelegado &&
                                <Col xs={12} md={4} xl={1} className="mb-sm-2  text-sm-center">
                                    <div className="container_botones">
                                        <button className="btnAprobarPlanificacion" onClick={() => setenviar(handlevalorenviar(enviar))}>Confirmar</button>
                                    </div>


                                </Col>
                            }

                            <Col xs={12} md={4} xl={1} className="mb-sm-2  text-sm-center">
                                <div className="container_botones">
                                    <button className="btnRechazarPlanificacion" onClick={() => cerrar_modal()}>Cancelar</button>
                                </div>

                            </Col>
                        </Row>

                    </Container>

                }

                {/* {!loading && !tabla_consulta_mes &&
                    <div>No hay planificaciones que mostrar</div>
                } */}
            </ModalBody>

        </Modal>
    )
}
export default ModalConsultaMensual;
